export const allowedCountries: string[] = ["indonesia"]